<template>
  <div>
    <div class="header_wrap">
      <div style="width: 60%">
        <el-steps style="width: 100%" align-center :active="4">
          <el-step title="海运信息"></el-step>
          <el-step title="增值服务"></el-step>
          <el-step title="托运信息"></el-step>
          <el-step title="确认委托"></el-step>
          <el-step title="委托完成"></el-step>
        </el-steps>
      </div>
    </div>
    <!-- --------------------------------内容 -->
    <div class="count_center">
      <div class="centerCoutn">
        <div style="width: 100%; text-align: center; margin-top: 82px">
          <i
            style="font-size: 55px; color: #00c300"
            class="el-icon-success animate__animated animate__bounceInDown"
          ></i>
          <p
            style="
              font-size: 20px;
              font-family: PingFang SC;
              font-weight: 500;
              color: #333333;
              margin-top: 27px;
            "
          >
            委托完成
          </p>
          <p
            style="
              font-size: 14px;
              font-family: PingFang SC;
              font-weight: 500;
              color: #999999;
              margin-top: 8px;
            "
          >
            等待货物入仓
          </p>
          <div class="countText">
            <p>运单号：{{ innos }}</p>
            <p>
              收货人：<span>{{ sendFeeForAir.name }}</span>
              <span style="margin-left: 10px">{{ sendFeeForAir.tel }}</span>
            </p>
            <p>
              收货地址：{{ sendFeeForAir.country }}{{ sendFeeForAir.city
              }}{{ sendFeeForAir.address }}
            </p>
          </div>
        </div>
        <div class="btnWrap" style="width: 100%; margin-top: 44px">
          <div class="LR_center" style="width: 328px">
            <div class="btn1" @click="pathBilltab()">查看订单</div>
            <div class="btn2" @click="nextSetbill()">继续下单</div>
            <!-- <div class="btn2" @click="nextSetbill()">下载入仓单</div> -->
          </div>
          <!-- <el-button @click="downLoadBill()" style="margin-left:10px"
           type="success" size="mini">下载入仓单</el-button> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import qs from "qs";
export default {
  data() {
    return {
      toOrder:false,
      innos: this.$route.query.nos,
      billId: this.$route.query.id,
      sendFeeForAir: JSON.parse(localStorage.getItem("sendFeeForAir")) || {
        name: "",
        tel: "",
        country: "",
        city: "",
        address: "",
      },
      Authorization: JSON.parse(localStorage.getItem("Authorization")),
    };
  },
  watch: {},
  computed: {},
  methods: {
    // downLoadBill(){
    //   this.axios.get(`/arap/getInWarehouseLabel/${this.billId}`,{
    //     responseType: 'arraybuffer'  /* 一定要加这个 不然文件内容显示不了 */
    //     })
    //   .then((res) => {
    //           let a = document.createElement('a');
    //           let blob = new Blob([res.data]);
    //           let objectUrl = URL.createObjectURL(blob);
    //           a.setAttribute("href",objectUrl);
    //           a.setAttribute("download", '入仓单.xls');
    //           a.click();
    //           // console.log(objectUrl);
    //           URL.revokeObjectURL(elink.href); // 释放URL 对象
    //           document.body.removeChild(a);// 释放标签

    //   }) .catch((res) => {
    //   console.log(res);
    //   });

    // },
    nextSetbill() {
      this.$router.push("/index/placeOrder/placeIndex");
    },
    // 点击去订单详情
    pathBilltab() {
      this.toOrder = true
      this.$router.push({
        name: "AirOrderDetail",
        query: this.$route.query,
      });
    },
  },
  destroyed() {
    // console.log(this);
    // console.log(this.$router);
    // console.log('destroyed');
       // 增值服务
    localStorage.removeItem("moreFeeListForAir");
    // 商品
    localStorage.removeItem("GoodListForAir");
    // 派送费
    // localStorage.removeItem("sendFeeForAir");
    // 提货费
    localStorage.removeItem("pickFeeForAir");
    // 运费
    localStorage.removeItem("transportFeeForAir");
    // 入仓时间
    localStorage.removeItem("inwarehousetime");
    // 备注
    localStorage.removeItem("remarksForAir");
  },
  beforeRouteLeave(to,from,next){
    // 去订单
    if(this.toOrder){
          // 增值服务
      localStorage.removeItem("moreFeeListForAir");
      // 商品
      localStorage.removeItem("GoodListForAir");
      // 派送费
      // localStorage.removeItem("sendFeeForAir");
      // 提货费
      localStorage.removeItem("pickFeeForAir");
      // 运费
      localStorage.removeItem("transportFeeForAir");
      // 入仓时间
      localStorage.removeItem("inwarehousetime");
      // 备注
      localStorage.removeItem("remarksForAir");

        next(true)
      this.$router.push({
        name: "AirOrderDetail",
        query: this.$route.query,
      });
    }else{
            next(true)
          this.$router.push({
            path: "/index/placeOrder/placeIndex",
          });
    }
   
    // // 如果有证明还没跳转过订单页面
    // if (JSON.parse(localStorage.getItem("GoodListForAir"))) {
   
     
    // }else{
    
    // }
     
  },
  created() {
    // 获取id 下载入仓单
    // this.billId = this.$route.query.id
    // // 单号
    // this.innos = this.$route.query.innos
    // console.log(this.$route.query.innos)
    // console.log(this.$route.query.nos2);
  },
  mounted() {},
};
</script>
<style scoped>
.btn1 {
  width: 157px;
  height: 36px;
  background: #ffffff;
  border: 1px solid #5f4aff;
  border-radius: 5px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #5f4aff;
  cursor: pointer;
}
.btn2 {
  width: 157px;
  height: 36px;
  background: #5f4aff;
  border-radius: 5px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #ffffff;
  cursor: pointer;
}
.countText {
  padding-top: 31px;
  width: 385px;
  margin: 0 auto;
  text-align: left;
  padding-left: 50px;
  box-sizing: border-box;
}
.countText p {
  margin-bottom: 10px;
}
.center_wrap {
  width: 100%;
}
.centerCoutn {
  width: 1099px;
  height: 471px;
  background: #ffffff;
  box-shadow: 0px 0px 20px 0px rgba(193, 193, 193, 0.21);
  border-radius: 10px;
  margin-top: 40px;
}
.header_wrap {
  width: 100%;
  height: 121px;
  margin-top: 33px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
}
.fontString {
  font-weight: bold;
}
.shouMargin {
  margin-bottom: 10px;
}
.ckttext {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #9a9a9a;
}
.good_count {
  margin-top: 65px;
}
.header_text {
  text-align: center;
  width: 100%;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
}
.count {
  width: 100%;
  padding-top: 30px;
}
.dialog >>> .el-dialog__body {
  padding: 0px 30px 30px 30px !important;
}
.dialog >>> .el-dialog__header {
  padding: 10px !important;
}
.tittype {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #333333;
  margin-left: 10px;
}
.auto_fixed {
  position: fixed;
  top: 20px;
  margin-left: 778px;
}
/* 左右对齐 */
.LR_center {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
}
.popWrap_l {
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  flex-flow: row nowrap;
  justify-content: space-between;
}
.btnWrap {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
}
/* 垂直居中 */
.count_center {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  /* column垂直 */
  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/components/airOrder/AirOrderSuccess.vue